import React, { useState, useEffect } from 'react';
import { IconButton } from '@chakra-ui/react';
import { FaChevronUp } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const MotionIconButton = motion(IconButton);

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <AnimatePresence>
            {isVisible && (
                <MotionIconButton
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.5 }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={scrollToTop}
                    position="fixed"
                    bottom="20px"
                    right="20px"
                    zIndex={100}
                    colorScheme="blackAlpha"
                    bg="rgba(0,0,0,0.6)"
                    color="white"
                    borderRadius="full"
                    size="md"
                    icon={<FaChevronUp />}
                    aria-label="Scroll to top"
                    boxShadow="lg"
                />
            )}
        </AnimatePresence>
    );
};

export default ScrollToTop;
